import React from "react";
import "./MessageSendSpinner.scss";

/** White spinner for blue Send / SEND message buttons */
const MessageSendSpinner = ({ size = 18 }) => (
  <span
    className="message-send-spinner"
    style={{ width: size, height: size }}
    aria-hidden="true"
  />
);

export default MessageSendSpinner;
